import { updateCompanyOwner } from 'common/api/companies';
import showToast from 'common/utils/showToast';

import { SAVE, SAVE_SUCCESS, SAVE_FAILURE } from '../actionTypes';
import { companyGeneralActions } from '../reducer';

import initializeForm from './initializeForm';

export default (values, onSuccessCallback) => (dispatch) => {
    dispatch(companyGeneralActions[SAVE]());

    updateCompanyOwner({ email: values.owner.email }, values.owner.id)
        .then((response) => {
            dispatch(companyGeneralActions[SAVE_SUCCESS](response.data));
            dispatch(
                initializeForm({
                    ...values,
                    owner: {
                        ...values.owner,
                        email: response.data.email,
                    },
                }),
            );
            if (onSuccessCallback) onSuccessCallback();
            showToast();
        })
        .catch((error) =>
            dispatch(
                companyGeneralActions[SAVE_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
